import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDownloadFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 25"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m11.261 15.403.03.031a1 1 0 0 0 .288.203q.001 0 .002.001l.055.023a1 1 0 0 0 .33.068h.003l.025.001H12l.044-.001h.002a1 1 0 0 0 .385-.097h.002a1 1 0 0 0 .307-.229l3.58-3.853a1 1 0 1 0-1.466-1.361L13 12.184V4.25a1 1 0 1 0-2 0v7.934l-1.854-1.995a1 1 0 1 0-1.465 1.361z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20 14.29a1 1 0 0 0-1 1v1.65a2.31 2.31 0 0 1-2.31 2.31H7.311A2.313 2.313 0 0 1 5 16.94v-1.65a1 1 0 1 0-2 0v1.65a4.316 4.316 0 0 0 4.311 4.31h9.379A4.316 4.316 0 0 0 21 16.94v-1.65a1 1 0 0 0-1-1"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgDownloadFilled);
export default ForwardRef;
